module.exports = __webpack_public_path__ + "static/chair-4d3edb6da38103ab4e71da57cbc8be9d.png";